import { formatDayShort } from './formatDayShort';
// formatDayLabel(1) -> "Mon."
// formatDayLabel([1, 2, 3]) -> "Mon. - Wed."
export const formatDayLabel = (day) => {
    const formatSingleDay = (singleDay) => `${formatDayShort(singleDay)}.`;
    if (Array.isArray(day)) {
        if (day.length === 1) {
            return formatSingleDay(day[0]);
        }
        const first = formatSingleDay(day[0]);
        const last = formatSingleDay(day[day.length - 1]);
        return `${first} - ${last}`;
    }
    return formatSingleDay(day);
};
